
import { Route, Routes } from 'react-router-dom';

import ObserveMaintenance from 'pages/monitoring/equipment-observe';
import EquipmentObserveViewMaintenance from 'pages/monitoring/equipment-observe-view';
import RouteAccessError from 'pages/RouteAccessError';
import PermissionRoute from 'components/route/PermissionRoute';
import { PERMISSIONS } from 'config/permissions';

export default function MonitoringEquipmentObserveRoutes() {
    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <ObserveMaintenance />
                        </PermissionRoute>
                    }
                />
                <Route path=":id" 
                    element={ 
                        <PermissionRoute
                            permission={PERMISSIONS.FRONT_READ}
                        >
                            <EquipmentObserveViewMaintenance />
                        </PermissionRoute> 
                    }
                 />
                <Route path="*" element={ <RouteAccessError /> }/>
            </Route>
        </Routes>
    );
}